// @flow
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';

export const HTMLDescription = styled.div`
  ${getFont(0)}
  color: ${({ textColor, theme }) => (textColor ? textColor : theme.colors.font)};
  margin-bottom: 24px;

  ul {
    padding-left: 12px;

    li:before {
      display: inline-block;
      margin-right: 6px;
      content: '•';
      vertical-align: sub;
      font-size: 28px;
      line-height: 1;
      color: ${({ theme }) => theme.colors.secondary};
    }
  }

  a {
    color: ${({ theme }) => theme.linkColor};
  }
`;

export const HTMLDescriptionSmall = styled(HTMLDescription)`
  ${getFont(-1, 'compact')}

  ul {
    li:before {
      font-size: 24px;
    }
  }
`;
